import styled from 'styled-components';

export const ChatListContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	overflow: hidden;
	background-color: #fff;
	border-right: 1px solid #e0e0e0;
`;

export const ChatList = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow-y: auto;
	background-color: #fff;
	border-right: 1px solid #e0e0e0;
	padding-top: 8px;
`;

export const ChatListItem = styled.div`
	display: flex;
	align-items: center;
	padding: 12px 16px;
	border-bottom: 1px solid #f0f2f5;
	background-color: ${props => props.selected ? '#f0f2f5' : '#fff'};
	cursor: pointer;
	transition: all 0.2s ease;
	width: 100%;
	box-sizing: border-box;
	position: relative;
	overflow: hidden;

	&:hover {
		background-color: #f5f6f6;
		padding-right: 48px;

		.chat-content {
			transform: translateX(-8px);
		}

		.status-button {
			opacity: 1;
		}
	}

	&[data-ended="true"] {
		opacity: 0.7;
		cursor: default;

		&:hover {
			background-color: #fff;
			padding-right: 16px;
      cursor: default;

			.chat-content {
				transform: none;
			}
		}

		.status-button {
			display: none;
		}
	}

	&[data-pending="true"] {
		padding-right: 48px;

		.chat-content {
			transform: translateX(-8px);
		}

		.status-button {
			opacity: 1;
		}
	}
`;

export const ChatListAvatar = styled.div`
	margin-right: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const ChatListInfo = styled.div`
	flex: 1;
	min-width: 0;
	margin-left: 12px;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const ChatContent = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	overflow: hidden;
	transition: transform 0.2s ease;
`;

export const ChatListName = styled.div`
	font-weight: 500;
	color: #111b21;
	margin-bottom: 4px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
`;

export const ChatListMessage = styled.div`
	color: #667781;
	font-size: 14px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
`;

export const LoadMoreButton = styled.button`
	padding: 12px;
	background: none;
	border: none;
	color: #00a884;
	cursor: pointer;
	font-weight: 500;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #f5f6f6;
	}
`;

export const ToggleButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	width: calc(100% - 32px);
	margin: 16px;
	padding: 12px 16px;
	background-color: #f0f2f5;
	color: #54656f;
	border: none;
	border-radius: 8px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	transition: all 0.2s ease;

	&:hover {
		background-color: #e4e6e8;
	}

	&:active {
		background-color: #d9dbdd;
	}

	svg {
		width: 20px;
		height: 20px;
	}
`;

export const StatusButton = styled.button`
	position: absolute;
	right: 16px;
	top: 50%;
	transform: translateY(-50%);
	width: 24px;
	height: 24px;
	padding: 0;
	background: none;
	border: none;
	cursor: pointer;
	opacity: 0;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${props => props.status === 'Pendente' ? '#00a884' : '#54656f'};

	&:hover {
		transform: translateY(-50%) scale(1.1);
	}

	svg {
		width: 20px;
		height: 20px;
	}
`;

export const FilterContainer = styled.div`
	display: flex;
	gap: 0;
	padding: 12px 16px;
	padding-bottom: 20px;
	border-bottom: 1px solid #e0e0e0;
	width: 90%;
	box-sizing: border-box;
	justify-content: center;
	margin: 0 auto;
`;

export const FilterButton = styled.button`
	padding: 8px;
	background-color: ${props => props.active ? '#00a884' : '#f0f2f5'};
	color: ${props => props.active ? 'white' : '#54656f'};
	border: none;
	border-radius: 0;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	transition: all 0.3s ease;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 42px;
	height: 52px;
	position: relative;
	overflow: hidden;
	flex: 1;
	min-width: 42px;
	box-sizing: border-box;

	&:first-child {
		border-top-left-radius: 8px;
		border-bottom-left-radius: 8px;
	}

	&:last-child {
		border-top-right-radius: 8px;
		border-bottom-right-radius: 8px;
	}

	&:hover {
		background-color: ${props => props.active ? '#008f72' : '#e4e6e8'};
		z-index: 10;

		svg {
			transform: scale(1.1);
		}
	}

	.filter-text {
		opacity: 1;
		width: auto;
		white-space: nowrap;
		transition: all 0.3s ease;
		margin-left: 0;
		margin-top: 2px;
		overflow: hidden;
		font-size: 11px;
		text-align: center;
	}

	svg {
		width: 20px;
		height: 20px;
		flex-shrink: 0;
		transition: transform 0.3s ease;
	}
`;

export const ChatListHeaderContainer = styled.div`
	display: flex;
	align-items: center;
	padding: 12px 16px;
	background-color: #f0f2f5;
	border-bottom: 1px solid #e0e0e0;
	gap: 8px;
`;

export const SearchInput = styled.input`
	width: 100%;
	padding: 8px 12px;
	border: none;
	border-radius: 8px;
	background-color: #fff;
	font-size: 14px;
	color: #111b21;
	outline: none;

	&::placeholder {
		color: #667781;
	}
`;